import { useQuery } from "@tanstack/react-query";
import _ from "lodash";
import { useProject } from "../project";
import { apiClient } from "../service/tekkr-service";

export function useProjectEventsQuery() {
    const { project } = useProject();
    return useQuery({
        queryKey: ["project-history", project.id],
        queryFn: async () => {
            const res = await apiClient.getProjectEvents({
                params: {
                    id: project.id,
                },
            });
            if (res.status !== 200) {
                throw new Error("Failed to fetch project events");
            }
            _.reverse(res.body.data);
            return res.body.data;
        },
    });
}
